import { reduce } from 'lodash';
const moment = require('moment');
import { Moment } from 'moment';
interface SearchParams {
  shop;
  month;
  endMonth;
  endMonthDate;
  startMonth;
  startMonthDate;
}
export default class DailyReportReviewController {
  loadingReports = false;
  showReport = false;
  list = [];
  report;
  reportIdToRestore;
  selectedShop;
  selectedMonth;
  daysOfMonth = [];

  searchParams: SearchParams;
  /*@ngInject*/
  constructor(private DailyReport, private $timeout) {}

  resetShop() {
    this.list = [];
  }
  shopSelected(shop, month) {
    this.loadingReports = true;
    this.selectedShop = shop;
    this.selectedMonth = month;
    this.showReport = false;
    this.report = null;
    var startMonthDate: Moment = moment(month)
      .local()
      .startOf('month');
    var endMonthDate: Moment = moment(month)
      .local()
      .endOf('month');
    var startMonth = moment(startMonthDate)
      .subtract(1, 'months')
      .format('YYYY-MM-DD');
    var endMonth = endMonthDate.format('YYYY-MM-DD');
    this.searchParams = {
      shop,
      month,
      endMonth,
      endMonthDate,
      startMonth,
      startMonthDate
    };
    this.refreshReports();
  }
  forceRefreshReports() {
    this.reportIdToRestore = this.report._id;
    this.refreshReports();
  }
  refreshReports() {
    var {
      shop,
      month,
      endMonth,
      endMonthDate,
      startMonth,
      startMonthDate
    } = this.searchParams;
    this.list = [];
    this.DailyReport.query({ id: shop._id, endMonth, startMonth }, result => {
      // console.log('reports', result);
      this.list = result.filter(e => {
        let date: Moment = moment(e.date);
        return date.month() === startMonthDate.month();
      });
      this.list.forEach(e => {
        let date: Moment = moment(e.date);
        let precReport = null;
        let beforeList = result.filter(e => date.isAfter(moment(e.date)));
        // console.log('beforeList', beforeList);
        do {
          date.subtract(1, 'days');
          // console.log(
          //   'searching for prec report of ',
          //   date.format('YYYY-MM-DD')
          // );
          precReport = result.find(e => date.isSame(moment(e.date)));
          beforeList = result.filter(e => date.isAfter(moment(e.date)));
        } while (precReport == null && beforeList.length > 0);
        if (precReport) {
          console.log('precReport', precReport.bills, '+', precReport.coins);
          e.startCash = (precReport.bills || 0) + (precReport.coins || 0);
          console.log('startCash', e.startCash);
        }
      });
      this.initDays(month);
      if (this.reportIdToRestore) {
        this.report = this.list.find(r => r._id === this.reportIdToRestore);
      }
      this.loadingReports = false;
    });
  }

  initDays(month) {
    this.daysOfMonth = [];
    var lastReport = this.list[this.list.length - 1];
    var lastDate = moment(lastReport.date)
      .local()
      .add(2, 'days');
    for (
      var day = moment(month)
        .local()
        .startOf('month')
        .add(1, 'days');
      day.isBefore(lastDate);
      day.add(1, 'days')
    ) {
      this.daysOfMonth.push(moment(day).startOf('day'));
    }
  }
  toggleReport() {
    this.showReport = false;
    this.$timeout(() => {
      this.showReport = true;
    }, 0);
  }
}



// WEBPACK FOOTER //
// ./client/app/manager/dailyReportReview/dailyReportReview.controller.ts